<template>
  <svg
    fill="curentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 33 32"
  >
    <path
      d="M16.536.435C7.86.435.826 7.468.826 16.145c0 7.367 5.073 13.549 11.915 15.247V20.945h-3.24v-4.8h3.24v-2.07c0-5.346 2.42-7.825 7.67-7.825.995 0 2.712.196 3.415.39v4.352c-.37-.039-1.015-.058-1.815-.058-2.576 0-3.571.976-3.571 3.512v1.698h5.131l-.881 4.801h-4.25V31.74c7.779-.94 13.806-7.563 13.806-15.595 0-8.676-7.034-15.71-15.71-15.71Z"
      fill="currentColor"
    />
  </svg>
</template>
